import { VisaServices } from "../../../Visa"

export default function VisaServicePage() {
	return (
		<VisaServices />
	)
}
